import { ArrowRight } from "lucide-react";

export function CtaBridge({ scrollTo }) {
  return (
    <section className="hm-section py-12 md:py-16" style={{ background: "var(--sky)" }} data-testid="cta-section">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="reveal" style={{ color: "var(--ink2)", lineHeight: 1.85, fontSize: "1.05rem" }} data-testid="cta-text">
          If any of this resonates with you, I'd love to explore how we might work together — whether through{" "}
          <span className="hm-keyword">strategic consulting</span>,{" "}
          <span className="hm-keyword">sharing stories</span>,{" "}
          <span className="hm-keyword">workshops and learning sessions</span>, or{" "}
          <span className="hm-keyword">cross-border partnerships</span>.
        </p>
        <div className="mt-8 reveal reveal-d1" data-testid="cta-button">
          <button onClick={() => scrollTo("contact")} className="hm-btn-filled">
            Start a conversation <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
